import * as _ from 'lodash';

import * as Edge from '../core';
import * as StrUtil from './strUtil';

export const getPriceTitle = (price: Edge.Models.Price) => {
	switch (price.priceType) {
		case Edge.Models.PriceTypes.Glasses:
			return '3D Glasses';
		case Edge.Models.PriceTypes.Recurring:
			return `${price.months}-Month Recurring Subscription`;
		case Edge.Models.PriceTypes.Sessions:
			return `${price.sessions}-Session Plan`;
		case Edge.Models.PriceTypes.Subscription:
			return `${price.months}-Month Subscription`;
		default:
			return 'new item';
	}
};

export const getPriceUnit = (price: Edge.Models.Price) => {
	switch (price.priceType) {
		case Edge.Models.PriceTypes.Glasses:
			return 'pair';
		case Edge.Models.PriceTypes.Recurring:
			return 'subscription';
		case Edge.Models.PriceTypes.Sessions:
			return 'set';
		case Edge.Models.PriceTypes.Subscription:
			return 'seat';
		default:
			return 'unit';
	}
};

export const getPriceTitleAndCount = (price: Edge.Models.Price, count: number) =>
	`${getPriceTitle(price)}, ${count} ${StrUtil.pluralize(getPriceUnit(price), count)}`;

export const getPriceFeatures = (price: Edge.Models.PriceDetail) => {
	return _.orderBy(
		_.filter(_.keys(price.price.metadata), (key: string) => {
			return Number.isInteger(parseInt(key));
		}),
		(i: string) => i
	).map((ix: string) => price.price.metadata[ix]);
};
